<template>
    <li
        class="product-filter-checkbox"
    >
        <v-checkbox
            :model-value="modelValue"
            class="opaque-label"
            density="compact"
            @update:model-value="onChange"
            hide-details
        >
            <template #label>
                <span
                    class="ms-2"
                >
                    <span>
                        {{ attrObj.name }}
                    </span>
                    <small
                        v-if="attrObj.description"
                        class="ms-2"
                    >
                        {{ attrObj.description }}
                    </small>
                </span>
            </template>
        </v-checkbox>
    </li>
</template>

<script lang="ts" setup>
    import type {
        ProductFilterAttributeValue
    } from '~/types';
    
    defineProps<{
        modelValue: boolean;
        attrObj: ProductFilterAttributeValue;
    }>();

    const emit = defineEmits<{
        'update:modelValue': [value: boolean];
    }>();

    function onChange(val: Nullable<boolean>): void {
        emit('update:modelValue', Boolean(val));
    }
</script>

<style lang="scss"></style>
